module.exports = __webpack_public_path__ + "img/player_icon_1_action.c68070b4.svg";